<div class="td-wb-modal-notification">
  <h1 class="td-wb-modal-notification__header"
      translate="tdWb.modalNotification.transactionHistory.TITLE"></h1>
  <div class="td-wb-modal-notification__row">
    <div class="td-wb-modal-notification__left">
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.transactionHistory.DESCRIPTION_I"></p>
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.transactionHistory.DESCRIPTION_II"></p>
     </div>
      <div class="td-wb-modal-notification--image-container">
        <img tdWbModalNotificationImage
             src="transtion-history.svg"
             class="td-wb-modal-notification--image-small"
             [attr.alt]="'tdWb.modalNotification.transactionHistory.IMAGE_ALT' | translate">
      </div>
  </div>
</div>
